import classNames from "classnames";
import { useRouter } from "hooks/useRouter";
import { useEffect, useState } from "react";
import UserService from "services/user.service";

const service = new UserService();

export const SolarDetails = () => {
  const [allLeads, setAllLeads] = useState([]);
  const [officeId, setOfficeId] = useState("");
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState([]);
  const [loadingStats, setLoadingStats] = useState(false);
  const { params } = useRouter();
  const [id, setId] = useState(params.id);
  const [data, setData] = useState<any>({});

  useEffect(() => {
    service
      .getSolarLead()
      .then((resp) => {
        setAllLeads(resp.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    // setId(params.id)
    setLoadingStats(true);
    service
      .solarDetails(id ?? "")
      .then((resp) => {
        setData(resp.data.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });

    service
      .getSolarStats(officeId ?? "")
      .then((resp) => {
        console.log(resp);
        setStats(resp.data.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoadingStats(false);
      });
  }, [id, params.id, officeId]);

  if (loading) {
    return (
      <div className="h-full w-full flex flex-col items-center justify-center">
        <p>Loading...</p>
      </div>
    );
  }
  const handleChangeSelect = (e) => {
    const { value } = e.target;
    setId(value);
    const find: any = allLeads.find((item: any) => item._id === value);
    if (find) {
      setOfficeId(find.id);
    }
  };

  return (
    <div>
      <select
        onChange={(e) => handleChangeSelect(e)}
        defaultValue={id}
        className="rounded-md border-gray-200 w-72 focus:border-gray-300 focus:ring-0 focus:outline-none"
      >
        {allLeads?.map((item: any) => (
          <option key={item?._id} value={item?._id}>
            {item?.office_name}
          </option>
        ))}
      </select>

      <div className="flex gap-4">
        <div className="w-full md:w-1/3">
          <div>
            <p className="mt-4 text-lg font-semibold">Lead Rules</p>

            <div className="card mt-1.5 flex flex-col px-4 py-2 divide-y divide-line">
              <div className="flex justify-between gap-4 py-3">
                <span>Office Name</span>
                <span>{data?.office_name}</span>
              </div>
              <div className="flex justify-between gap-4 py-3">
                <span>Order Type</span>
                <span>{data?.order_type}</span>
              </div>
              <div className="flex justify-between gap-4 py-3">
                <span>Order KPI</span>
                <span>{data?.orderKpi}</span>
              </div>
              <div className="flex justify-between gap-4 py-3">
                <span>KPI Duration</span>
                <span>
                  {data?.kpiDuration === "weekly"
                    ? "Previous 7 Days"
                    : data?.kpiDuration === "bimonthly"
                    ? "Previous 14 Days"
                    : "Previous 30 Days"}
                </span>
              </div>
            </div>
          </div>
          <div className="flex-1">
            <p className="text-lg mt-4 font-semibold">
              Current Solar Pro Order
            </p>

            <div className="bg-white w-full mt-1.5 shadow-sm border overflow-hidden border-zinc-200 flex flex-col   rounded-lg divide-y divide-zinc-200">
              {data?.solar_closure?.map((item, index) => (
                <div key={item.badge_id} className="flex gap-4 ">
                  <div
                    className={classNames(
                      "w-36 text-center font-semibold p-3 text-white bg-blue-600"
                    )}
                  >
                    {index === 0
                      ? "NEXT UP"
                      : index === 1
                      ? "ON DECK"
                      : index === 2
                      ? "IN THE WHOLE"
                      : null}
                  </div>
                  <span className="flex-1 py-3">{item.closure_name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="flex-1">
          <p className="mt-4 text-lg font-semibold">Stats</p>

          <div className="relative overflow-x-auto shadow-sm mt-1.5 border border-zinc-200 sm:rounded-lg">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500">
              <thead className="text-xs text-gray-700 uppercase bg-gray-100 ">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    Rank
                  </th>

                  <th scope="col" className="px-6 py-3">
                    Solar Pro
                  </th>
                  <th scope="col" className="px-6 py-3">
                    CS
                  </th>
                  <th scope="col" className="px-6 py-3">
                    P%
                  </th>
                  <th scope="col" className="px-6 py-3">
                    CS%
                  </th>
                </tr>
              </thead>
              <tbody>
                {loadingStats  &&  (
                  <tr >
                    <td colSpan={5} className="py-8 bg-white text-center bg-opacity-70 flex-col items-center justify-center  w-full h-full ">
                      <div role="status">
                        <svg
                          aria-hidden="true"
                          className="w-full h-9 mr-2 text-center text-gray-200 animate-spin-slow dark:text-gray-600 fill-primary"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill"
                          />
                        </svg>
                        <span className="sr-only">Loading...</span>
                      </div>
                      <p className="ml-3 mt-1 font-medium text-gray-700">
                        Loading Stats...
                      </p>
                    </td>
                  </tr>
                )}
                {stats.map((item: any, index) => (
                  <tr
                    key={index}
                    className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                  >
                    <td className="px-6 py-4">{++index}</td>

                    <th
                      scope="row"
                      className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                      {item?.name}
                    </th>
                    <td className="px-6 py-4">{item?.close_percentage}</td>
                    <td className="px-6 py-4">{item?.pitch_percentage}</td>
                    <td className="px-6 py-4">{item?.contract_signed}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
